export const NEW_IMPORTED_ITEM = "NEW_IMPORTED_ITEM";
export const UPDATE_IMPORTED_ITEM = "UPDATE_IMPORTED_ITEM";
export const NOOP_IMPORTED_ITEM = "NOOP_IMPORTED_ITEM";



// WEBPACK FOOTER //
// ./src/constants/csvImportTypes.js